import { apiPostAsUser } from './api_v2';
import db from './db';
import { currentUserId } from './meta';

async function assertOkActivityResponse(response) {
  const data = await response.json();
  if (!(response.ok && data.ok)) {
    const errors = Array.isArray(data.errors) ? data.errors : [];
    throw new Error(errors.join(', ') || 'Activity request failed');
  }
  return data;
}

async function unreadActivitiesSnapshot() {
  const userId = currentUserId();
  if (!userId) return [];

  const rows = await db.activities
    .where('recipient_user_id')
    .equals(userId)
    .filter((activity) => activity.read_at == null)
    .toArray();

  return rows;
}

export async function markAllActivitiesRead() {
  const previousRows = await unreadActivitiesSnapshot();
  const now = Math.floor(Date.now() / 1000);

  if (previousRows.length > 0) {
    await db.activities.bulkPut(previousRows.map((activity) => ({ ...activity, read_at: now, updated_at: now })));
  }

  try {
    await assertOkActivityResponse(await apiPostAsUser('/activities/read_all'));
  } catch (error) {
    if (previousRows.length > 0) await db.activities.bulkPut(previousRows);
    throw error;
  }
}
